import React from 'react';
import { cx } from '@twind/core';

import CloseIcon from './icons/CloseIcon';

export default function CloseBubble({
  onClick,
  className,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}) {
  return (
    <button
      id="ostro-bubble-close-button"
      onClick={onClick}
      className={cx(
        '~(bg-white p-[6px] rounded-full shadow-[0px_4px_4px_rgba(0,0,0,0.25)] flex items-center justify-center)',
        className
      )}
      aria-label="close bubble messages"
    >
      <CloseIcon className="fill-black text-black w-2" />
    </button>
  );
}
